export const MESSAGE_TYPE = {
  WARNING: "warning",
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  DEFAULT: "default",
};
